import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'
import { Sm2Crypto } from './sm2'

const TokenKey = 'Authorization-Token'
const UserKey = 'Current-User'
const EncryptionKey = 'your-encryption-key-32' // 32位密钥，用于加密令牌

// 获取令牌
export function getToken() {
  try {
    const token = Cookies.get(TokenKey)
    if (token) {
      console.log('getToken: 从Cookie获取到Token')
      return token
    }
    // 兜底从 localStorage 获取
    const localToken = localStorage.getItem('token')
    if (localToken) {
      console.log('getToken: 从localStorage获取到Token')
      return localToken
    }
    return ''
  } catch (error) {
    console.error('Get Token Error:', error)
    return ''
  }
}

// 设置令牌
export function setToken(token, expires = 1) {
  try {
    if (!token) return false
    
    // 如果 expires 是秒数（如后端返回的 3600），转换为天数或者直接使用 Date 对象
    let cookieExpires = expires
    if (typeof expires === 'number' && expires > 100) {
      // 认为是秒数，转换为天数
      cookieExpires = expires / (24 * 3600)
    }
    
    console.log('setToken: 设置Token到Cookie, 过期时间(天):', cookieExpires)
    // 明确设置 path: '/'
    return Cookies.set(TokenKey, token, { expires: cookieExpires, path: '/' })
  } catch (error) {
    console.error('Set Token Error:', error)
    return false
  }
}

// 移除令牌
export function removeToken() {
  localStorage.removeItem('token')
  localStorage.removeItem('tokenExpire')
  sessionStorage.removeItem('token')
  return Cookies.remove(TokenKey)
}

// 获取当前用户信息
export function getUser() {
  const localUserStr = localStorage.getItem(UserKey)
  if (localUserStr) {
    try {
      return JSON.parse(localUserStr)
    } catch (error) {
      console.error('Parse local user error:', error)
      localStorage.removeItem(UserKey)
    }
  }

  const cookieUserStr = Cookies.get(UserKey)
  if (cookieUserStr) {
    try {
      const user = JSON.parse(cookieUserStr)
      localStorage.setItem(UserKey, cookieUserStr)
      return user
    } catch (error) {
      console.error('Parse cookie user error:', error)
      Cookies.remove(UserKey)
    }
  }

  return null
}

// 设置当前用户信息
export function setUser(user) {
  try {
    if (!user) return false
    const userStr = JSON.stringify(user)
    localStorage.setItem(UserKey, userStr)
    Cookies.set(UserKey, userStr, { expires: 1, path: '/' })
    return true
  } catch (error) {
    console.error('Set User Error:', error)
    return false
  }
}

// 移除当前用户信息
export function removeUser() {
  localStorage.removeItem(UserKey)
  return Cookies.remove(UserKey)
}

// 加密数据（保留原有功能用于非敏感数据）
export function encrypt(data) {
  if (!data) return ''
  try {
    const key = CryptoJS.enc.Utf8.parse(EncryptionKey)
    const iv = CryptoJS.enc.Utf8.parse(EncryptionKey.substring(0, 16)) // 16位初始化向量
    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(data),
      key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    )
    return encrypted.toString()
  } catch (error) {
    console.error('Encryption Error:', error)
    return data // 加密失败时返回原始数据
  }
}

// 解密数据（保留原有功能用于非敏感数据）
export function decrypt(data) {
  if (!data) return ''
  try {
    const key = CryptoJS.enc.Utf8.parse(EncryptionKey)
    const iv = CryptoJS.enc.Utf8.parse(EncryptionKey.substring(0, 16)) // 16位初始化向量
    const decrypted = CryptoJS.AES.decrypt(
      data,
      key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    )
    return decrypted.toString(CryptoJS.enc.Utf8)
  } catch (error) {
    console.error('Decryption Error:', error)
    return data // 解密失败时返回原始数据
  }
}

// SM2加密密码（与后端兼容）
export async function sm2EncryptPassword(password, captcha) {
  try {
    // 验证验证码格式
    if (!Sm2Crypto.validateCaptchaFormat(captcha)) {
      throw new Error('验证码必须是5位字符')
    }
    
    // 使用新的SM2加密实现
    console.log('开始SM2加密密码...')
    return await Sm2Crypto.encryptPasswordWithCaptcha(password, captcha)
  } catch (error) {
    console.error('密码加密错误:', error)
    // 如果加密失败，返回Base64编码的原始数据作为备用方案
    const encoder = new TextEncoder()
    const combinedData = captcha + password
    return btoa(encoder.encode(combinedData))
  }
}

// 检查是否已登录
export function isLoggedIn() {
  return !!getToken()
}

// 清除所有认证信息
export function clearAuthInfo() {
  removeToken()
  removeUser()
}

// 生成随机密钥
export function generateRandomKey(length = 32) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+~`|}{[]:;?><,./-='
  let result = ''
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return result
}
